import * as React from "react";

import { cn } from "../../utils/cn";

import { textVariants } from "./text";

function Label({
    className,
    ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>): React.ReactElement {
    return (
        <label
            data-slot="label"
            className={cn(
                textVariants({ variant: "body" }),
                "flex items-center gap-2 text-foreground-base select-none",
                "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
                "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
                className
            )}
            {...props}
        />
    );
}

export { Label };
